export const getEnvironmentByOrigin =  () => {
    const origin = window.location.origin;
    if (origin.includes('localhost')) {
      return 'development'
    }
    if (origin.includes('dev')) {
      return 'staging';
    } else {
      return 'production';
    }
}
